class CommunityTeaser
    constructor: (el) ->
        @.$el = el
        @.$lists = undefined
        @.$tabHeader = @.$el.querySelector '.community-teaser__forums__tab-header'
        @.$tabButtons = undefined

        @.InitEvents()
        @.$el.classList.add 'community-teaser--bound'
        return
    
    InitEvents: ->
        if @.$tabHeader
            self = @
            @.$lists = @.$el.querySelectorAll '.community-teaser__forums__list'
            @.$tabButtons = @.$tabHeader.querySelectorAll '.community-teaser__forums__tab-button'
            @.$tabButtons.forEach (tabButton) ->
                tabButton.addEventListener 'click', (e) ->
                    e.preventDefault()
                    activeButton = self.$tabHeader.querySelector '.community-teaser__forums__tab-button--active'
                    activeButton.classList.remove 'community-teaser__forums__tab-button--active'
                    activeButtonBadge = activeButton.querySelector '.badge'
                    if activeButtonBadge
                        activeButtonBadge.dispatchEvent new CustomEvent 'badge-set-withdraw', {
                            bubbles: false,
                            detail: {
                                withdraw: true
                            }
                        }
                    self.$el.querySelector '.community-teaser__forums__list:not(.community-teaser__forums__list--hidden)'
                        .classList.add 'community-teaser__forums__list--hidden'
                    index = Array.prototype.indexOf.call self.$tabButtons, @
                    self.$lists[index].classList.remove 'community-teaser__forums__list--hidden'
                    @.classList.add 'community-teaser__forums__tab-button--active'
                    newActiveButtonBadge = @.querySelector '.badge'
                    if newActiveButtonBadge
                        newActiveButtonBadge.dispatchEvent new CustomEvent 'badge-set-withdraw', {
                            bubbles: false,
                            detail: {
                                withdraw: false
                            }
                        }  
                    return
                return
        return

BindCommunityTeasers = ->
    document.querySelectorAll '.community-teaser:not(.community-teaser--bound)'
        .forEach (el) ->
            new CommunityTeaser el
            return
    return

window.addEventListener 'bind-components', BindCommunityTeasers